const initState = () => ({
    idlogin:"",
    user:'',
    seedetailservice:[],
    loadingdetail:false,
    profilemenumargin:false,
    typeOfBusiness: [],
    token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjVjZGJmZTcwMGExOWViMTBhNGU1MDdmNyIsImlhdCI6MTU1ODkyODkyMH0.9PXT6F5LxA_YMQ8jOx0znclkZXeDIG82EycGysieaTc',
    checkToken:'',
    isOpenModalCreate:true,
    typeOfBusinessConst:[]
  });
  
  export default initState;
  


// WEBPACK FOOTER //
// ./src/store/initState.js